import { render } from "./IreAreasEditing.vue?vue&type=template&id=002b946a&ts=true"
import script from "./IreAreasEditing.vue?vue&type=script&lang=ts"
export * from "./IreAreasEditing.vue?vue&type=script&lang=ts"

import "./IreAreasEditing.vue?vue&type=style&index=0&id=002b946a&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__